<!-- <section class="container-fluid rc-container">
  <div class="card mt-5"> -->

    <div class="rc-edit-form-bg">
      <p-table styleClass="p-datatable-striped p-datatable-sm"
               [columns]="displayedColumns"
               [value]="dataSource"
               selectionMode="single"
               [(selection)]="selectedServiceProduct"
               scrollabe="true"
               [scrollHeight]="tableHeight"
               dataKey="id"
               (onRowSelect)="onRowSelect($event)"
               [tableStyle]="{'min-width': '50rem'}">
        <ng-template pTemplate="caption">
          <div class="flex align-items-center justify-content-between">
            Services
            <p-button class="btn btn-primary"
                      (click)="onAddServiceProduct()"
                      type="button">Add</p-button>

                      <!-- <p-dropdown
                      class="mr-1"
                      [options]="serviceProductTypePDropdownItems"
                      [(ngModel)]="selectedImportTypeDropdownItem"
                      (onChange)="filePicker.click()"
                      optionLabel="value"
                      placeholder="Import Type">
          </p-dropdown> -->

            <p-button class="btn btn-primary"
                      (click)="filePicker.click()">
              Import</p-button>
            <input type="file"
                   [hidden]="true"
                   #filePicker
                   (change)="onImportServiceProducts($event,selectedImportTypeDropdownItem)">
            <p-button class="btn btn-primary"
                      (click)="onDone()">Done</p-button>
          </div>
        </ng-template>
        <ng-template pTemplate="header"
                     let-columns>
          <tr>
            <th *ngFor="let col of columns"
            [style.width]="col.width">
              {{ col.header }}
            </th>
          </tr>
        </ng-template>

        <ng-template pTemplate="body"
                     let-rowData
                     let-columns="columns">
          <tr id="userTableRowId"
              [pSelectableRow]="rowData">
            <td *ngFor="let col of columns"
                [ngSwitch]="col.field">
              <span class="p-column-title">{{col.header}}</span>
              <ng-container *ngSwitchCase="'actions'">
                <ng-container>
                  <div class="flex justify-content-center flex-wrap gap-3">
                    <p-button class="action-button"
                              icon="pi pi-user-edit"
                              [rounded]="true"
                              (click)="onEditServiceProduct(rowData);$event.stopPropagation()"
                              pTooltip="Edit Service"></p-button>
                    <p-button class="action-button"
                              icon="pi pi-trash"
                              [rounded]="true"
                              (click)="onDeleteServiceProduct(rowData);$event.stopPropagation()"
                              pTooltip="Delete Service"></p-button>
                  </div>
                </ng-container>
              </ng-container>
              <ng-container *ngSwitchDefault> {{ rowData[col.field] }}
              </ng-container>
            </td>
          </tr>
        </ng-template>
      </p-table>
    </div>
  <!-- </div>
</section> -->
